export enum ContactsSearchOrder {
  OrderByContactId = 1,
  OrderByAlias = 2,
  OrderByFirstName = 3,
  OrderByLastName = 4,
  OrderByCompanyName = 5,
  OrderByEmail = 6,
}

export enum ContactType {
  Person = 1,
  Company = 2,
}

export enum ContractEmailType {
  PEC = 1,
  Email = 2,
}

export enum ImportContactState {
  Error = 1,
  Imported = 2,
  Missed = 3,
}
